import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SpinnerService } from './shared/services/spinner.service';
import { SharedModule } from './shared/shared.module';
import { FcmService } from './core/fcm/fcm.service';
import { RolePreviewBannerComponent } from 'app/core/permissions/role-preview-banner.component';
import { WorkspaceService } from 'app/core/workspace/workspace.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, SharedModule, RolePreviewBannerComponent],
})
export class AppComponent  implements OnInit{
    showSpinner: boolean = false;

    // WorkspaceService est créé ici, avant la première navigation, pour en suivre toutes les pages.
    constructor(private spinnerService: SpinnerService, private cdRef: ChangeDetectorRef,private fcmService: FcmService,
                _workspace: WorkspaceService) {}

    ngOnInit(): void {
        this.spinnerService.getSpinnerObserver().subscribe((status: boolean) => {
            // Pas de detectChanges() synchrone ici : une requête HTTP peut partir pendant le
            // rendu d'une vue (ex. chargement d'une icône SVG dans une cellule de mat-table).
            // Relancer la détection de changements à ce moment-là corrompait le premier rendu
            // des templates (« ASSERTION ERROR: Reached the max number of directives ») et
            // plus aucun tableau ne s'affichait. On diffère la mise à jour à la micro-tâche suivante.
            Promise.resolve().then(() => {
                this.showSpinner = status;
                this.cdRef.markForCheck();
            });
        });
    }

}
